import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { setBackHandler, setHeaderTitle } from "../../helpers/header.helper";
import { useLocation, useNavigate } from "react-router";
import { pageTitles, ToasterTexts } from "../shared/constants";
import { CancelIcon, DeleteButtonIcon, DragHolderGrayIcon, GreenTickIcon, InfoIcon, MediaDefaultIcon, MediaTxtIcon, PdfIcon, ShowAllIcon, TicketingDropdownIcon, UploadIconGrayIcon, WhatsappTemplateCallPhonenumberIcon, WhatsappTemplateCopyOfferCodeIcon, WhatsappTemplateInfoIcon, WhatsappTemplateQuickReplyIcon, WhatsappTemplateVisitWebsiteIcon, WordIcon, XlsIcon, ZipIcon } from "../../icon";
import { Autocomplete, Checkbox, Popover, TextField, Tooltip, Zoom } from "@mui/material";
import RichEditor from "../shared/richtext-editor/rich-text-editor.component";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";
import { MediaFileType, MediaType } from "../../models/media.models";
import ImageComponent from "../shared/media/image.component";
import Video from "../shared/media/video.component";
import AudioType from "../shared/media/audio.component";
import { Node } from 'slate';
import CustomSwitch from "../shared/switch.component";
import { lastIndexOf } from "lodash";
import ButtonComponent from "../shared/button/button.component";
import { WhatsappService } from "../../services/channels/whatsappService";
import { ChannelUserModel, mapToChannelUser } from "../../models/users.model";
import { AppRoutes } from "../routes/route.path";

export class TemplateButtonModel {
    ButtonType: number;
    TypeOfAction: number;
}

enum ButtonTypes {
    QuickReply = 1,
    CallToAction
}

enum QuickReply {
    Marketing = 1,
    Custom
}

enum CallToAction {
    VisitWebSite = 3,
    CallPhonenumber,
    CopyOfferCode
}

const initialValue = [
    {
        type: "paragraph",
        children: [{ text: "" }]
    }
];

const AddWhatsappTemplateEditAndPreviewComponent = () => {

    const user = mapToChannelUser(JSON.parse(localStorage.getItem("current-user"))) as ChannelUserModel;

    const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;

    const CallToActionTypeOptions = [{ Name: "Visit Website", Value: 3, Selected: true }, { Name: "Call phone number", Value: 4, Selected: true }, { Name: "Copy code offer", Value: 5, Selected: true }]

    const urlTypes = [{ Name: "Static", Value: 1 }, { Name: "Dynamic", Value: 2 }]

    const QucikReplyTypeOptions = [{ Name: "Marketing opt-out", Value: 1 }, { Name: "Custom", Value: 2 }]

    const Countries = [{ Name: "India", ISO: "IN", Value: "+91" }, { Name: "United States", ISO: "US", Value: "+1" }, { Name: "United Kingdom", ISO: "GB", Value: "+44" }]

    const navigate = useNavigate();

    const location = useLocation()

    const addButtonref = React.createRef<HTMLDivElement>();

    const [templateType, setTemplateType] = useState<string>("")
    const [templateName, setTemplateName] = useState<string>("")
    const [headerType, setHeaderType] = useState<string>("None")
    const [header, setHeader] = useState<any>("")
    const [headerWithVariable, setHeaderWithVariable] = useState<string>("")
    const [headerVariable, setHeaderVariable] = useState<string>("")
    const [headerVariableSampleError, setHeaderVariableSampleError] = useState<string>("")
    const [body, setBody] = useState<typeof initialValue>([{
        type: "paragraph",
        children: [{ text: "Hello" }]
    }])
    const [bodyPreview, setBodyPreview] = useState<any>("")
    const [bodyVariables, setBodyVariable] = useState<{ Id: number, value: string, error: string }[]>([])
    const [bodyVariableCount, setBodyVariableCount] = useState<number>(0)
    const [bodyStringCount, setBodyStringCount] = useState<number>(0)
    const [footer, setFooter] = useState<string>("")
    const [media, setMedia] = useState("");
    const [mediaUrl, setMediaUrl] = useState("");
    const [mediatype, setMediatype] = useState("");
    const [mediaName, setMediaName] = useState("");
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [anchorAddButon, setAnchorAddButton] = useState<Element | null>(null);
    const [quickReplyButtons, setQuickReplyButtons] = useState<{ ActionType: number, ButtonText: string, FooterText?: string, ButtonTextError: string, Id: number }[]>([])
    const [callToActionButtons, setCallToActionButtons] = useState<{ ActionType: number, ButtonText: string, UrlType?: number, Url?: string, ContryCode?: string, PhoneNumber: string, OfferCode?: string, ButtonTextError: string, PhoneNumberError?: string, OfferCodeError: string, UrlError: string, DynamicUrl?: string, DynamicUrlError?: string, Id: number }[]>([])
    const [marketingOptOutChecked, setMarketingOptOutChecked] = useState<boolean>(false)
    const [quickReplyOrder, setQuickReplyOrder] = useState<number>()
    const [callToActionOreder, setCallToActionOrder] = useState<number>()
    const [allAddedButtons, setAllAddedButtons] = useState<any>([])
    const [showAll, setShowAll] = useState<boolean>(false);
    const [messageValidityPeriod, setMessageValidityPeriod] = useState("")
    const [customValidityPeriod, setCustomValidityPeriod] = useState<boolean>(false)
    const [errors, setErrors] = useState<{ templateName: boolean, header: boolean, body: boolean, buttons: boolean }>({ templateName: true, header: false, body: false, buttons: false })
    const [isloading, setIsLoading] = useState<boolean>(false)

    const dragStart = useRef<number>(0);
    const dragEnter = useRef<number>(0);

    const handelDrag = (type: number) => {
        const QucikSort: any = type === ButtonTypes.QuickReply ? [...quickReplyButtons] : [...callToActionButtons]
        const currentPostion = QucikSort[dragStart.current];
        QucikSort[dragStart.current] = QucikSort[dragEnter.current];
        QucikSort[dragEnter.current] = currentPostion;
        if (type === ButtonTypes.QuickReply) {
            setQuickReplyButtons(QucikSort);
        }
        else {
            setCallToActionButtons(QucikSort)
        }
    }

    const handleBodyPreview = (Body) => {

        let convertedBody = Body[0].children.map((x) => {
            let children = x.text.replace(/{{(\d+)}}/g, (match, number) => {
                return bodyVariables[parseInt(number) - 1]?.value || match;
            });;
            if (x.bold) {
                children = <b>{children}</b>
            }

            if (x.strikethrough) {
                children = <s>{children}</s>
            }

            if (x.italic) {
                children = <i>{children}</i>
            }

            if (x.underline) {
                children = <u>{children}</u>
            }

            return children
        }
        )

        return <div>{convertedBody}</div>

    }

    const slateTostring = (body) => {

        let convertedBodyPayload = body[0].children.map((x) => {
            let formattedText = x.text

            if (x.bold) {
                formattedText = `*${formattedText}*`;
            }
            if (x.italic) {
                formattedText = `_${formattedText}_`;
            }
            if (x.strikethrough) {
                formattedText = `~${formattedText}~`;
            }

            return formattedText
        }
        ).join("")

        return convertedBodyPayload

    }

    useEffect(() => {
        setHeaderTitle(pageTitles.TEMPLATES);
        setBackHandler(() => navigate(-1));
    }, []);

    useEffect(() => {
        setBodyPreview((handleBodyPreview(body)))
    }, [body, bodyVariables])

    useLayoutEffect(() => {
        setTemplateType(location.pathname.slice(location.pathname.lastIndexOf("/") + 1, location.pathname.length))
    }, [])

    const handleTemplateName = (e) => {
        if (e.target.value.length === 0) {
            setErrors({ ...errors, templateName: true })
        }
        else {
            if (e.target.value.length > 512) {
                setErrors({ ...errors, templateName: true })
            }
            else {
                setErrors({ ...errors, templateName: false })
            }
        }
        setTemplateName(e.target.value)
    }

    const handleHeaderType = (value) => {
        let Errors = { ...errors }

        setHeaderType(value)
        setErrors(Errors)
        setMedia("")
        setMediaName("")
        setMediaUrl("")
        setMediatype("")
        setHeader("")
        setHeaderVariable("")

        if (value === "None") {
            setErrors({ ...Errors, header: false })
        }
        else {
            setErrors({ ...Errors, header: true })
        }
    }

    const handleHeaderVariable = () => {
        if (header.length < 54 && !header.includes("{{1}}")) {
            setHeader(header + " {{1}} ")
            setHeaderVariableSampleError("please enter sample for variable")
            setErrors({ ...errors, header: true })
        }
    }

    const handleHeaderVariableSample = (e) => {
        setHeaderVariable(e.target.value)
        if (e.target.value.trim().length) {
            setErrors({ ...errors, header: false })
            setHeaderVariableSampleError("")
        }
        else {
            setErrors({ ...errors, header: true })
            setHeaderVariableSampleError("please enter sample for variable")
        }
    }

    const handleHeader = (e) => {
        setHeader(e.target.value)
        if (!e.target.value.trim().length) {
            setErrors({ ...errors, header: true })
        }
        else {
            if (!e.target.value.includes("{{1}}")) {
                setHeaderVariable("")
                setErrors({ ...errors, header: false })
            }
            if (e.target.value.includes("{{1}}") && !headerVariable) {
                setErrors({ ...errors, header: true })
                setHeaderVariableSampleError("please enter sample for variable")
            }
        }
    }

    const convertMBtoByte = (mb: number) => {
        return mb * 1024 * 1024
    }
    const getFileSizeLimit = (fileType: string, headerType: string): number => {
        const type = fileType.split('/')[0].toLowerCase();

        if (type === "image" && headerType === "Image") return convertMBtoByte(2);
        if (type === "video" && headerType === "Video") return convertMBtoByte(20);
        if (type === "audio" && headerType === "Audio") return convertMBtoByte(16);
        if (fileType.includes("application") && headerType === "Document") return convertMBtoByte(100);

        return convertMBtoByte(10);
    };

    const handleMediaChange = async (e: any) => {
        let file = (e?.target?.files[0] || e);
        if (file !== undefined) {
            const fileSizeLimit = getFileSizeLimit(file.type, headerType);
            if (file != null && (headerType.toLowerCase() === file.type.split('/')[0] || (file.type.includes("application") && headerType === "Document"))) {
                if (file != null && file.size < fileSizeLimit) {
                    if (e.target) { e.target.value = "" }
                    setMedia(file);
                    setMediaUrl(await toBase64(file));
                    setMediatype(file.type.includes("application") ? file.name.split('.')[file.name.split('.')?.length - 1] : file.type.split('/')[0]);
                    setMediaName(file.name);
                    setErrors({ ...errors, header: false })
                }
                else {
                    if (e.target) { e.target.value = "" }
                    setToast(ToasterTexts.FILE_SIZE_EXCEED_LIMIT.replace("File", headerType).replace("<size>", (fileSizeLimit / convertMBtoByte(1)).toFixed(0)), ToasterType.DANGER)
                }
            }
            else {
                setToast("The selected header type and the uploaded file type are different!", ToasterType.DANGER)
            }

        }
    }

    const toBase64 = (file: any) =>
        new Promise<any>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const getMediaTypeIcon = (type: any, urlMedia: string, size?: string) => {
        if (type != null) {
            switch (type) {
                case MediaType.IMAGE:
                case MediaType.IMAGE_GIF:
                case MediaType.IMAGE_JPEG:
                case MediaType.IMAGE_ARW:
                case MediaType.IMAGE_PNG:
                case MediaType.IMAGE_WEBP:
                    return (
                        <ImageComponent
                            MediaUrl={urlMedia}
                            classname={size}
                            text={true}
                        />
                    );
                case MediaType.VIDEO:
                    return <Video MediaUrl={urlMedia} controls={false} />;
                case MediaType.AUDIO:
                case MediaType.AUDIO_MP3:
                case MediaType.AUDIO_MPeg:
                    return <AudioType MediaUrl={urlMedia} controls={true} />
                case MediaFileType.PDF:
                    return <PdfIcon className={size} />
                case MediaFileType.ZIP:
                    return <ZipIcon className={size} />
                case MediaFileType.DOC:
                    return <WordIcon className={size} />
                case MediaFileType.DOCX:
                    return <WordIcon className={size} />
                case MediaFileType.XLSX:
                    return <XlsIcon className={size} />
                case MediaFileType.TXT:
                    return <MediaTxtIcon className={size} />
                default:
                    return <MediaDefaultIcon className={size} />
            }
        }
    };

    const cancelMedia = () => {
        setMedia("");
        setMediaName("");
        setMediaUrl("");
        setMediatype("");
    }

    const handleButtonErrors = (buttons) => {
        let Buttons = buttons.map(x => buttons.filter(y => y.Id != x.Id)?.map(z => z.ButtonText).includes(x.ButtonText) ? { ...x, ButtonTextError: "cannot have same name for multiple buttons" } : !x.ButtonText.trim() ? { ...x, ButtonTextError: "cannot be empty" } : { ...x, ButtonTextError: "" })
        Buttons = Buttons.map(x => x.ActionType === CallToAction.CallPhonenumber ? { ...x, PhoneNumberError: !!x.PhoneNumber.trim().length ? "" : "Phone Number cannot be empty" } : x.ActionType === CallToAction.CopyOfferCode ? { ...x, OfferCodeError: !!x.OfferCode.trim().length ? "" : "Offer Code cannot be empty" } : x.ActionType === CallToAction.VisitWebSite ? { ...x, UrlError: !!x.Url.trim().length ? urlRegex.test(x.Url) ? "" : "please enter valid url" : "Url cannot be empty", DynamicUrlError: x.UrlType === 2 ? !!x.DynamicUrl.trim() ? urlRegex.test(x.DynamicUrl) ? "" : "please enter valid url" : "url cannot be blank" : "" } : x)
        setErrors({ ...errors, buttons: Buttons.find(x => x.ButtonTextError || x.PhoneNumberError || x.UrlError || x.DynamicUrlError || x.OfferCodeError || (Buttons.find(x => x.ActionType === QuickReply.Marketing && marketingOptOutChecked))) })
        return Buttons
    }

    const onChangeQuickReply = (type: number) => {
        setQuickReplyButtons(handleButtonErrors([...quickReplyButtons, { ActionType: type, ButtonText: type === QuickReply.Marketing ? "Stop promotions" : "Quick Reply", FooterText: type === QuickReply.Marketing ? "Not interested? Tap Stop promotions" : "", ButtonTextError: "", Id: new Date().valueOf() }]))
        setAnchorAddButton(null)
        if (!!callToActionButtons?.length && quickReplyOrder !== 1) {
            setQuickReplyOrder(2)
            setCallToActionOrder(1)
        }
        else {
            setCallToActionOrder(2)
            setQuickReplyOrder(1)
        }
    }

    useEffect(() => {
        if (!!quickReplyOrder && quickReplyOrder === 1) {
            setAllAddedButtons([...quickReplyButtons, ...callToActionButtons])
        }
        else {
            setAllAddedButtons([...callToActionButtons, ...quickReplyButtons])
        }
    }, [callToActionButtons, quickReplyButtons])

    const onChangeCallToAction = (type: number) => {
        setCallToActionButtons(handleButtonErrors([...callToActionButtons, { ActionType: type, ButtonText: type === CallToAction.CopyOfferCode ? "Copy offer code" : type === CallToAction.CallPhonenumber ? "Call phone number" : "Visit Website", UrlType: type === CallToAction.VisitWebSite && 1, Url: "", DynamicUrl: "", ContryCode: type === CallToAction.CallPhonenumber && "+1", PhoneNumber: "", OfferCode: "", ButtonTextError: "", Id: new Date().valueOf() }]))

        setAnchorAddButton(null)

        if (!!quickReplyButtons?.length && callToActionOreder !== 1) {
            setQuickReplyOrder(1)
            setCallToActionOrder(2)

        }
        else {
            setCallToActionOrder(1)
            setQuickReplyOrder(2)
        }
    }

    const onChangeQuickReplyAction = (e: any, value, id: number) => {
        const selectedOption = quickReplyButtons.map(x => x.Id === id ? { ...x, ActionType: value.Value, ButtonText: value.Value === QuickReply.Marketing ? "Stop promotions" : "Quick Reply", FooterText: value.Value === QuickReply.Marketing ? "Not interested? Tap Stop promotions" : "", ButtonTextError: "", Id: id } : x)

        setQuickReplyButtons(handleButtonErrors(selectedOption))
    }

    const onChangeQuickReplyButtonText = (e: any, id: number) => {
        const selectedOption = quickReplyButtons.map(x => x.Id === id ? { ...x, ActionType: x.ActionType, ButtonText: e.target.value, FooterText: "", Id: id } : x)

        setQuickReplyButtons(handleButtonErrors(selectedOption))
    }

    const onChangeQuickReplyFooterText = (e: any, id: number) => {
        const selectedOption = quickReplyButtons.map(x => x.Id === id ? { ...x, ActionType: x.ActionType, ButtonText: x.ButtonText, FooterText: e.target.value, Id: id } : x)
        setQuickReplyButtons(selectedOption)
    }

    const removeQuickReply = (id: number) => {
        setQuickReplyButtons(handleButtonErrors(quickReplyButtons.filter(x => x.Id !== id)))
        quickReplyButtons.find(x => x.Id === id).ActionType === QuickReply.Marketing && setMarketingOptOutChecked(false)
        !quickReplyButtons.filter(x => x.Id !== id)?.length && setQuickReplyOrder(2);
    }

    const onChangeCallToActionType = (e: any, value, id: number) => {
        const selectedOption = callToActionButtons.map(x => x.Id === id ? { ...x, ActionType: value.Value, ButtonText: value.Value === CallToAction.CopyOfferCode ? "Copy offer code" : value.Value === CallToAction.CallPhonenumber ? "Call phone number" : "Visit Website", UrlType: value.Value === CallToAction.VisitWebSite && 1, ContryCode: value.Value === CallToAction.CallPhonenumber && "+1", Url: "", DynamicUrl: "" } : x)

        setCallToActionButtons(handleButtonErrors(selectedOption))
    }

    const onChangeCallToActionButtonText = (e: any, id: number) => {
        const selectedOption = callToActionButtons.map(x => x.Id === id ? { ...x, ActionType: x.ActionType, ButtonText: e.target.value, } : x)

        setCallToActionButtons(handleButtonErrors(selectedOption))
    }

    const onChangeCallToActionUrlType = (e: any, value, id: number) => {
        const selectedOption = callToActionButtons.map(x => x.Id === id ? { ...x, ActionType: x.ActionType, UrlType: value.Value } : x)

        setCallToActionButtons(selectedOption)
    }

    const onChangeCallToActionWebsiteUrl = (e: any, id: number) => {
        const selectedOption = callToActionButtons.map(x => x.Id === id ? { ...x, ActionType: x.ActionType, Url: e.target.value, } : x)

        setCallToActionButtons(handleButtonErrors(selectedOption))
    }

    const onChangeCallToActionWebsiteDynamicUrl = (e: any, id: number) => {
        const selectedOption = callToActionButtons.map(x => x.Id === id ? { ...x, ActionType: x.ActionType, DynamicUrl: e.target.value, } : x)

        setCallToActionButtons(handleButtonErrors(selectedOption))
    }

    const onChangeCallToActionCountryChange = (e: any, value, id: number) => {
        const selectedOption = callToActionButtons.map(x => x.Id === id ? { ...x, ActionType: x.ActionType, ContryCode: value.Value, } : x)

        setCallToActionButtons(handleButtonErrors(selectedOption))
    }

    const onChangeCallToActionPhonenumber = (e: any, id: number) => {
        const selectedOption = callToActionButtons.map(x => x.Id === id ? { ...x, ActionType: x.ActionType, PhoneNumber: e.target.value, } : x)

        setCallToActionButtons(handleButtonErrors(selectedOption))
    }

    const onChangeCallToActionOfferCode = (e: any, id: number) => {
        const selectedOption = callToActionButtons.map(x => x.Id === id ? { ...x, ActionType: x.ActionType, OfferCode: e.target.value.trim(), } : x)

        setCallToActionButtons(handleButtonErrors(selectedOption))
    }

    const removeCallToAction = (id: number) => {
        setCallToActionButtons(handleButtonErrors(callToActionButtons.filter(x => x.Id !== id)))
        !callToActionButtons.filter(x => x.Id !== id)?.length && setCallToActionOrder(2)
    }

    const handleBodyError = (variableCount, stringCount, text, variables) => {
        if ((text[0].children.map(x => x.text).join("").length > 1024) || (variableCount >= stringCount / 2) || (!text[0].children.filter(x => !!x.text).length) || (!!variables?.find(x => !!x.error.length))) {
            setErrors({ ...errors, body: true })
        }
        else {
            setErrors({ ...errors, body: false })
        }
    }

    const handleBodyVariable = (e, Id) => {
        let variables = bodyVariables.map(x => x.Id === Id ? { ...x, value: e.target.value, error: e.target.value.length ? "" : "please enter sample text" } : x)
        setBodyVariable(variables)
        handleBodyError(bodyVariableCount, bodyStringCount, body, variables)
    }

    const appendVariable = () => {
        let count = !!body[0].children.map(x => x.text.match(/{{\d+}}/g)).filter(x => x != null).length ? body[0].children.map(x => x.text.match(/{{\d+}}/g)).flat(Infinity).filter(x => x != null).length : 0
        let stringCount = body[0].children.map(x => x.text.split(/\s+/).filter(x => !(/\{\{\d+\}\}/).test(x))).flat(Infinity).filter(x => !!x.length).length
        setBodyStringCount(stringCount)
        setBodyVariableCount(bodyVariableCount + 1)
        setBodyVariable([...bodyVariables, { Id: new Date().getMilliseconds(), value: "", error: "please enter a sample text" }])
        setBody([{ ...body[0], children: [...body[0].children, { text: ` {{${count + 1}}}` }] }])
        handleBodyError(count + 1, stringCount, [{ ...body[0], children: [...body[0].children, { text: ` {{${count + 1}}}` }] }], [...bodyVariables, { Id: new Date().getMilliseconds(), value: "", error: "please enter a sample text" }])
    }

    const handleBody = (value) => {
        let count = !!value[0].children.map(x => x.text.match(/{{\d+}}/g)).filter(x => x != null).length ? value[0].children.map(x => x.text.match(/{{\d+}}/g)).flat(Infinity).filter(x => x != null).length : 0
        let stringCount = value[0].children.map(x => x.text.split(/\s+/).filter(x => !(/\{\{\d+\}\}/).test(x))).flat(Infinity).filter(x => !!x.length).length
        setBodyStringCount(stringCount)
        setBodyVariableCount(count)
        setBody(value)
        setBodyVariable(bodyVariables.length >= count ? bodyVariables.filter((x, index) => index + 1 <= count) : [...bodyVariables, { Id: new Date().getMilliseconds(), value: "", error: "please enter a sample text" }])
        handleBodyError(count, stringCount, value, bodyVariables.filter((x, index) => index + 1 <= count))
    }

    const urlbuttonPayload = (x) => {
        let urlButton: any = {
            type: "URL",
            text: x.ButtonText,
            url: x.Url,
        }

        if (x.Url.includes("{{1}}")) {
            urlButton = { ...urlButton, example: [x.DynamicUrl] }
        }

        return urlButton
    }

    const createTemplate = () => {
        setIsLoading(true)
        let formData = new FormData()

        if (!!media) {
            formData.append("file", media)
        }

        let Header: any = {
            type: "HEADER",
            format: headerType.toUpperCase(),
        }

        let Body: any = {
            type: "BODY",
            text: slateTostring(body),
        }

        let Footer = {
            type: "FOOTER",
            text: footer
        }

        let Buttons = {
            type: "BUTTONS",
            buttons: []
        }

        let payload: any = {
            name: templateName,
            language: "en",
            category: templateType === "UtilityCustom" ? "UTILITY" : "MARKETING",
        }

        if (headerType.toUpperCase() === "TEXT") {
            Header = { ...Header, text: header }
            if (header.includes("{{1}}")) {
                Header = {
                    ...Header,
                    text: header,
                    example: {
                        header_text: [
                            headerVariable
                        ]
                    }
                }
            }
        }

        if (headerType.toUpperCase() !== "TEXT" && headerType !== "None") {
            Header = {
                ...Header, example: {
                    header_handle: [
                        ""
                    ]
                }
            }
        }

        if (!!bodyVariableCount) {
            Body = {
                ...Body, example: {
                    body_text: [bodyVariables.map(x => x.value)]
                }
            }
        }

        if (!!quickReplyButtons.length) {
            Buttons = {
                ...Buttons, buttons: quickReplyButtons.map(x => {
                    return {
                        type: "QUICK_REPLY",
                        text: x.ButtonText
                    }
                })
            }
        }

        if (!!callToActionButtons.length) {
            Buttons = {
                ...Buttons, buttons: [...Buttons.buttons, callToActionButtons.map(x => {
                    return x.ActionType === CallToAction.CallPhonenumber ?
                        {
                            type: "PHONE_NUMBER",
                            text: x.ButtonText,
                            phone_number: x.PhoneNumber
                        }
                        : x.ActionType === CallToAction.VisitWebSite ?
                            urlbuttonPayload(x)
                            : {
                                type: "COPY_CODE",
                                example: x.ButtonText
                            }
                })]
            }
        }

        payload = {
            ...payload, components: [
                Body
            ]
        }

        if (!!Buttons.buttons.length) {
            payload = { ...payload, components: [...payload.components, Buttons] }
        }

        if (footer.length) {
            payload = { ...payload, components: [...payload.components, Footer] }
        }

        if (headerType.toUpperCase() !== "TEXT" && headerType !== "None") {
            WhatsappService.whatsappMediaUpload("66bce7c4ec8cac0c4f99c226", formData).then(res => {
                Header = { ...Header, example: { header_handle: [res.data] } }

                payload = { ...payload, components: [...payload.components, { ...Header, example: { header_handle: [res.data] } }] }

                WhatsappService.CreateTemplate(user.ID, "66bce7c4ec8cac0c4f99c226", payload).then(() => {
                    navigate(AppRoutes.ADD_WHATSAPP_TEMPLATES_SUCCESS_SCREEN)
                    setIsLoading(false)
                })
            })
        }
        else {
            if (headerType.toUpperCase() === "TEXT") {
                payload = { ...payload, components: [...payload.components, Header] }
            }

            WhatsappService.CreateTemplate(user.ID, "66bce7c4ec8cac0c4f99c226", payload).then(() => {
                navigate(AppRoutes.ADD_WHATSAPP_TEMPLATES_SUCCESS_SCREEN)
                setIsLoading(false)
            })
        }

    }


    return (
        <div className='w-p-100 h-p-100 bg-color-grid d-flex justify-center align-center'>
            <div className='w-p-96 h-p-96 bg-color-secondary br-2 d-flex justify-center align-center'>
                <div className="w-p-60 h-p-100 d-flex flex-direction">
                    <div className="w-p-86 h-10 d-flex justify-center align-center h3-semibold color-nav-bar-font-color mx-auto">
                        <GreenTickIcon className="w-2 h-2 mr-1" />
                        <div className="color-add-whatsapp-template-stepper-sucess">
                            Set up Template&nbsp;&nbsp;
                        </div>
                        <div className="bb-bottom-nav-bar-font-color w-2">

                        </div>
                        <div className="color-primary-light">
                            &nbsp;&nbsp;Edit & Preview&nbsp;&nbsp;
                        </div>
                        <div className="bb-bottom-nav-bar-font-color w-2">

                        </div>
                        <div>
                            &nbsp;&nbsp;Submit for review
                        </div>
                    </div>
                    <div className="w-p-100 h-p-82 o-y-scroll">
                        <div className="w-p-86 h-10 d-flex justify-between mx-auto">
                            <div className="w-p-60 h-p-100">
                                <div className="w-p-100 h-p-40 h4-medium color-text-field-label">
                                    Template Name
                                </div>
                                <div className="w-p-100 h-p-60">
                                    <TextField
                                        label="Name"
                                        className="w-p-100"
                                        size="small"
                                        variant="outlined"
                                        value={templateName}
                                        onChange={(e) => handleTemplateName(e)}
                                        error={errors.templateName}
                                        inputProps={{ maxLength: 512 }}
                                        helperText={<div className=" h6-medium w-p-100 d-flex justify-between"><span className={`${templateName.length === 0 ? "color-primary-danger" : ""} ml-auto`}>{templateName.length}/512 characters used</span></div>}
                                    />
                                </div>
                            </div>
                            <div className="w-p-36 h-p-100">
                                <div className="w-p-100 h-p-40 h4-medium color-text-field-label">
                                    Language
                                </div>
                                <div className="w-p-100 h-p-60">
                                    <Autocomplete
                                        className="w-p-100"
                                        size="small"
                                        options={["English"]}
                                        value={"English"}
                                        disabled
                                        renderInput={(params) => <TextField {...params} name="select" required variant="outlined" placeholder="Type" />}
                                        disableClearable
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="w-p-86 h-4 d-flex align-center h4-medium mx-auto color-text-field-label">
                            Content
                        </div>
                        <div className="w-p-86 add-phone-number-paper-border br-2 mx-auto d-flex flex-direction align-center">
                            <div className="w-p-94 h-4 d-flex align-center h5-semibold color-primary-accent mt-1">
                                Header
                            </div>
                            <Autocomplete
                                value={headerType}
                                className="w-p-94 mb-2 h5-regular"
                                size="small"
                                options={["None", "Text", "Image", "Video", "Document", "Location"]}
                                renderInput={(params) => <TextField {...params} name="Type" required variant="outlined" placeholder="Optional" className="h5-regular" />}
                                disableClearable
                                onChange={(e, value) => { handleHeaderType(value) }}
                            />
                            {headerType === "Text" &&
                                <>
                                    <TextField
                                        placeholder="Optional"
                                        className="w-p-94 mb-2"
                                        size="small"
                                        variant="outlined"
                                        value={header}
                                        onChange={(e) => { handleHeader(e) }}
                                        inputProps={{ maxLength: 60 }}
                                        helperText={<div className="w-p-100 h6-medium d-flex justify-between"><span className={`${header.length === 0 ? "color-primary-danger" : ""}`}>{header.length}/60 characters used</span><div className={`h5-semibold c-pointer ${(header.length > 53 || header.includes("{{1}}")) ? "color-secondary-light-hover" : "color-primary-light"}`} onClick={handleHeaderVariable}>
                                            + Add Variable <Tooltip title="You can add atmost one variable in header" placement='top-start' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }} className='ml-auto'>
                                                <InfoIcon className='' />
                                            </Tooltip>
                                        </div></div>}
                                    />
                                </>
                            }
                            {(headerType === "Text" && header.includes("{{1}}")) && <>
                                <div className="w-p-94 h-4 d-flex align-center h4-medium">
                                    Sample text for variable
                                </div>
                                <div className="w-p-94 d-flex align-center h6-medium color-secondary-light-hover">
                                    To help us review your content, provide examples of the variables or media in the header.
                                    Do not include any customer information. Cloud API hosted by Meta
                                    reviews templates and variable parameters to protect the security and integrity of our services.
                                </div>
                                <div className="w-p-94 d-flex h4-medium color-text-field-label align-center my-1">
                                    <div className="mb-auto mt-1 color-primary-accent">&#123;&#123;1&#125;&#125;&nbsp;</div>
                                    <TextField
                                        className="w-p-100"
                                        size="small"
                                        variant="outlined"
                                        value={headerVariable}
                                        onChange={(e) => handleHeaderVariableSample(e)}
                                        error={!!headerVariableSampleError}
                                        helperText={<div className="w-p-100 d-flex justify-flex-end h6-medium">{headerVariableSampleError}</div>}
                                    />
                                </div>
                            </>
                            }

                            {(headerType !== "Text" && headerType !== "None" && !!headerType && headerType !== "Location") &&
                                <div className="import-contacts-border br-2 w-p-94 h-15 mb-2 d-flex align-center justify-center"
                                    onDrop={(event) => {
                                        event.preventDefault()
                                        const files = Array.from(event.dataTransfer.items).map((item) => item.getAsFile() as File)
                                        files.forEach(async (file) => {
                                            if (file !== null) {
                                                handleMediaChange(file)
                                            }
                                        })
                                    }}
                                    onDragOverCapture={(event) => {
                                        event.preventDefault();
                                    }}
                                    onDragLeave={(event) => { }}
                                >
                                    {!media ?
                                        <div>
                                            <input
                                                color="primary"
                                                accept={headerType === "Image" ? `image/png,image/jpg,image/jpeg,` : headerType === "Video" ? `video/*` : headerType === "Audio" ? `audio/*` : `.pdf,.doc,.docx,.xlsx,.zip`}
                                                type="file"
                                                onChange={handleMediaChange}
                                                id={"icon-button-file"}
                                                style={{ display: 'none' }}
                                            />
                                            <label htmlFor={"icon-button-file"} className="d-flex flex-direction align-center w-p-100">
                                                <div className="w-4 h-4 bg-color-falkon-chat-dashboard-banner br-50 d-flex align-center justify-center"><UploadIconGrayIcon /></div>
                                                <div className="color-primary-danger h5-medium py-1 c-pointer">Drag and drop image or browse file</div>
                                                <div className="footnote-medium color-live-chat-anonymous">Recommended size 256 x 256 less than 1 MB</div>
                                            </label>

                                        </div>
                                        : <div className="d-flex align-center">
                                            {getMediaTypeIcon(mediatype, mediaUrl, "w-10 h-10")}
                                            <CancelIcon className="ml-3 w-3 h-3 c-pointer" onClick={() => cancelMedia()} />
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                        <div className="w-p-86 add-phone-number-paper-border br-2 mx-auto d-flex flex-direction align-center mt-2">
                            <div className="w-p-94 h-5 d-flex align-center justify-between h5-semibold color-primary-accent">
                                <div>
                                    Body*
                                </div>
                                <div className="color-primary-light h5-semibold c-pointer" onClick={() => appendVariable()}>
                                    + Add Variable
                                </div>
                            </div>
                            <div className="w-p-94 mb-3 d-flex flex-direction">
                                <RichEditor IsMobileDevice={false} value={body} setValue={(value: Node[]) => handleBody(value)} isRedonly={false} Whatsapptemplates={true} />
                                <div className="w-p-100 d-flex justify-between h6-medium color-text-field-label"><span className={`${(body[0].children.map(x => x.text).join("").length > 1024 || body[0].children.map(x => x.text).join("").length === 0) && "color-primary-danger"} ml-auto`}>{body[0].children.map(x => x.text).join("").length}/1024 characters used</span></div>
                            </div>
                            {bodyVariableCount >= (bodyStringCount) / 2 && !!bodyVariableCount &&
                                <div className="w-p-94 d-flex align-center color-primary-danger h6-regular">
                                    This template contains too many variable parameters relative to the message length.
                                    You need to decrease the number of variable parameters or increase the message length.                                </div>
                            }
                            {!!bodyVariableCount &&
                                <>
                                    <div className="w-p-94 h-4 d-flex align-center h4-medium">
                                        Samples for body content
                                    </div>
                                    <div className="w-p-94 d-flex align-center h6-medium color-secondary-light-hover">
                                        To help us review your message template, please add an example for each variable in your body text.
                                        Do not use real customer information. Cloud API hosted by Meta reviews templates and variable
                                        parameters to protect the security and integrity of our services.
                                    </div>
                                    {bodyVariables.map((x, index) => <div className="w-p-94 d-flex h4-medium color-text-field-label align-center my-1">
                                        <div className="mb-auto mt-1 color-primary-accent">&#123;&#123;{index + 1}&#125;&#125;&nbsp;</div>
                                        <TextField
                                            className="w-p-100"
                                            size="small"
                                            variant="outlined"
                                            value={x.value}
                                            onChange={(e) => handleBodyVariable(e, x.Id)}
                                            error={!!x.error}
                                            helperText={<div className="h6-medium w-p-100 d-flex justify-flex-end">{x.error}</div>}
                                        />
                                    </div>)}
                                </>
                            }
                        </div>
                        <div className="w-p-86 add-phone-number-paper-border br-2 mx-auto d-flex flex-direction align-center mt-2">
                            <div className="w-p-94 h-4 d-flex align-center h5-semibold color-primary-accent mt-1">
                                Footer
                            </div>
                            <TextField
                                placeholder="Optional"
                                className="w-p-94 mb-2"
                                size="small"
                                variant="outlined"
                                value={footer}
                                onChange={(e) => { setFooter(e.target.value) }}
                                inputProps={{ maxLength: 60 }}
                                helperText={<div className="h6-medium w-p-100 d-flex justify-between"><span className={`ml-auto`}>{footer.length}/60 characters used</span></div>}
                            />
                        </div>

                        <div className="w-p-86 add-phone-number-paper-border br-2 mx-auto mt-2 py-2">
                            <div className="w-p-94 h-4 d-flex align-center h4-medium color-primary-accent mx-auto">
                                Buttons
                            </div>
                            <div className="w-p-94 d-flex align-center h5-regular color-text-field-label mx-auto">
                                Create buttons that let customers respond to your message or take action. You can add up to ten buttons. If you add more than three buttons, they will appear in a list.
                            </div>
                            <div className={` w-p-94 mx-auto h-6 mt-1 d-flex align-center  h4-medium`}>
                                <div className={`d-flex align-center c-pointer py-1 px-2 br-2 ${[...callToActionButtons, ...quickReplyButtons]?.length >= 10 ? "bg-color-disabled-btn-unauth color-secondary" : "b-primary-light color-primary-light"}`}
                                    ref={addButtonref}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        if (Boolean(anchorAddButon)) {
                                            setAnchorAddButton(null)
                                        } else {
                                            [...callToActionButtons, ...quickReplyButtons]?.length < 10 && setAnchorAddButton(addButtonref.current)
                                        }
                                    }}
                                >
                                    <div>+ Add Button</div>
                                    <div><TicketingDropdownIcon className="ml-2" /></div>
                                </div>
                            </div>
                            <div className="w-p-92 mx-auto mt-1 box-shadow-unread-label d-flex p-1 align-center br-1">
                                <div><InfoIcon /></div>
                                <div className="ml-1">
                                    <div className="h4-semibold">
                                        We recommend adding the marketing opt-out button
                                    </div>
                                    <div className="h6-medium">
                                        Allow customers to request to opt out of all marketing messages. This can help reduce blocks from customers and increase your quality rating. <a href="https://www.facebook.com/business/help/448422200528701" target="_blank" className="color-primary-light" >Learn more.</a>
                                    </div>
                                </div>
                            </div >
                            <div className="d-flex flex-direction">
                                <div style={{ order: callToActionOreder }}>{
                                    !!callToActionButtons?.length &&
                                    <div className=" w-p-94 mx-auto bg-color-disabled-btn-unauth py-1 br-2 my-2">
                                        <div className="h3-medium ml-2">Call to action</div>
                                        {callToActionButtons.map((x, index) => {
                                            return <div className="d-flex align-center c-move bg-color-secondary w-p-96 mx-auto br-2 mt-1 justify-between"
                                                draggable
                                                onDragStart={() => (dragStart.current = index)}
                                                onDragEnter={() => (dragEnter.current = index)}
                                                onDragEnd={() => handelDrag(ButtonTypes.CallToAction)}
                                                onDragOver={(e) => e.preventDefault()}
                                            >
                                                <div className="w-p-85 mx-auto br-2">
                                                    <div className="p-2">

                                                        <div className="d-flex justify-between w-p-100">
                                                            <div className="w-p-45">
                                                                <div className="h5-regular color-text-field-label">Type of action</div>
                                                                <div className="">
                                                                    <Autocomplete
                                                                        disablePortal
                                                                        options={CallToActionTypeOptions}
                                                                        size="small"
                                                                        disableClearable
                                                                        getOptionLabel={(option: any) => option?.Name}
                                                                        value={CallToActionTypeOptions.find(option => option.Value === x.ActionType)}

                                                                        getOptionDisabled={(option) => {
                                                                            const count = callToActionButtons?.filter(x => x.ActionType === option?.Value)?.length || 0;

                                                                            if ((option.Value === CallToAction.CallPhonenumber || option.Value === CallToAction.CopyOfferCode)) {
                                                                                return count >= 1;
                                                                            } else {
                                                                                return count >= 2;
                                                                            }
                                                                        }}
                                                                        onChange={(e, value) => onChangeCallToActionType(e, value, x.Id)}
                                                                        renderInput={(params) => <TextField {...params} />}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="w-p-45">
                                                                <div className="h5-regular color-text-field-label">Button text</div>
                                                                <div className="">
                                                                    <TextField
                                                                        className="w-p-100"
                                                                        size="small"
                                                                        disabled={x.ActionType === CallToAction.CopyOfferCode}
                                                                        value={x.ButtonText}
                                                                        onChange={(e) => onChangeCallToActionButtonText(e, x.Id)}
                                                                        InputProps={{
                                                                            classes: { input: `${'h4-regular'} color-text-field-font` },
                                                                            style: {
                                                                                backgroundColor: x.ActionType === CallToAction.CopyOfferCode ? '#F1F4F7' : 'transparent',
                                                                            }
                                                                        }}
                                                                        error={!!x.ButtonTextError}
                                                                        helperText={<div className="h6-medium w-p-100 d-flex justify-flex-end">{x.ButtonTextError}</div>}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {x.ActionType === CallToAction.VisitWebSite &&
                                                            <div className="d-flex justify-between mt-2 w-p-100">
                                                                <div className="w-p-45">
                                                                    <div className="h5-regular color-text-field-label">URL Type</div>
                                                                    <div className="">
                                                                        <Autocomplete
                                                                            disablePortal
                                                                            options={urlTypes}
                                                                            size="small"
                                                                            disableClearable
                                                                            getOptionLabel={(option: any) => option?.Name}
                                                                            value={urlTypes.find(option => option.Value === x.UrlType)}
                                                                            renderOption={(defaultprops, option: any) => (
                                                                                <li {...defaultprops} className={'c-pointer h4-regular color-menu-list-font-color p-1 d-flex justify-between'}>
                                                                                    {option.Name}
                                                                                </li>
                                                                            )}
                                                                            onChange={(e, value) => onChangeCallToActionUrlType(e, value, x.Id)}
                                                                            renderInput={(params) => <TextField {...params} />}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="w-p-45">
                                                                    <div className="h5-regular color-text-field-label">Website URL</div>
                                                                    <div className="">
                                                                        <TextField
                                                                            className="w-p-100"
                                                                            size="small"
                                                                            value={x.Url}
                                                                            onChange={(e) => onChangeCallToActionWebsiteUrl(e, x.Id)}
                                                                            error={!!x.UrlError}
                                                                            helperText={<div className=" h6-medium w-p-100 d-flex justify-flex-end">{x.UrlError}</div>}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {x.UrlType === 2 && <div className="w-p-100 d-flex pt-1 h6-regular color-text-field-label flex-direction">
                                                            <div className="d-flex">
                                                                <div className="h4-semibold mr-3 color-primary-accent">Add Sample URL</div>
                                                                <div className="">{`{{1}}`}
                                                                    <Tooltip title="Adding a variable creates a personalised link for the customer to view their info. Only one variable can be added to the end of a URL." placement='top-start' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }} >
                                                                        <InfoIcon className='c-pointer ml-1' />
                                                                    </Tooltip>
                                                                </div>
                                                            </div>
                                                            <div>To help us review your message template, please add an example of the website URL. Do not use real customer information.</div>
                                                            <div className="w-p-100 d-flex mt-1">
                                                                <div className="pt-1 mr-1 h4-semibold color-primary-accent">{`{{1}}`}
                                                                </div>
                                                                <div className=" w-p-90">
                                                                    <TextField
                                                                        className="w-p-100"
                                                                        size="small"
                                                                        value={x.DynamicUrl}
                                                                        onChange={(e) => onChangeCallToActionWebsiteDynamicUrl(e, x.Id)}
                                                                        error={!!x.DynamicUrlError}
                                                                        helperText={<div className=" h6-medium w-p-100 d-flex justify-flex-end">{x.DynamicUrlError}</div>}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        }

                                                        {x.ActionType === CallToAction.CallPhonenumber &&
                                                            <div className="d-flex justify-between mt-2 w-p-100">
                                                                <div className="w-p-45">
                                                                    <div className="h5-regular color-text-field-label">Country</div>
                                                                    <div className="">
                                                                        <Autocomplete
                                                                            disablePortal
                                                                            options={Countries}
                                                                            size="small"
                                                                            disableClearable
                                                                            getOptionLabel={(option: any) => `${option?.ISO} ${option.Value}`}
                                                                            value={Countries.find(option => option.Value === x.ContryCode)}
                                                                            renderOption={(defaultprops, option: any) => (
                                                                                <li {...defaultprops} className={'c-pointer h4-regular color-menu-list-font-color p-1 d-flex justify-between'}>
                                                                                    {option.Name}
                                                                                    <div>{option.Value}</div>
                                                                                </li>
                                                                            )}
                                                                            onChange={(e, value) => onChangeCallToActionCountryChange(e, value, x.Id)}
                                                                            renderInput={(params) => <TextField {...params} />}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="w-p-45">
                                                                    <div className="h5-regular color-text-field-label">Phone number</div>
                                                                    <div className="">
                                                                        <TextField
                                                                            className="w-p-100"
                                                                            size="small"
                                                                            value={x.PhoneNumber}
                                                                            onChange={(e) => onChangeCallToActionPhonenumber(e, x.Id)}
                                                                            error={!!x.PhoneNumberError}
                                                                            inputProps={{ maxLength: 20,}}
                                                                            helperText={<div className={`h6-medium w-p-100 d-flex justify-between ${x.PhoneNumberError && "color-primary-danger"}`}><span className={`ml-auto`}>{x.PhoneNumber.length}/20 characters used</span></div>}  
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }

                                                        {x.ActionType === CallToAction.CopyOfferCode &&
                                                            <div className="d-flex justify-between mt-2 w-p-100">
                                                                <div className="w-p-100">
                                                                    <div className="h5-regular color-text-field-label">Offer code</div>
                                                                    <div className="w-p-100">
                                                                        <TextField
                                                                            className="w-p-100"
                                                                            size="small"
                                                                            value={x.OfferCode}
                                                                            onChange={(e) => onChangeCallToActionOfferCode(e, x.Id)}
                                                                            error={!!x.OfferCodeError}
                                                                            inputProps={{ maxLength: 15 }}
                                                                            helperText={<div className={`h6-medium w-p-100 d-flex justify-between ${x.OfferCodeError && "color-primary-danger"}`}><span className={`ml-auto`}>{x.OfferCode.length}/15 characters used</span></div>}                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="w-p-10 d-flex flex-direction justify-center align-center">
                                                    <DeleteButtonIcon onClick={() => removeCallToAction(x.Id)} className="c-pointer" />
                                                    <DragHolderGrayIcon className="mt-1" />
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                }
                                </div>
                                <div style={{ order: quickReplyOrder }}> {
                                    !!quickReplyButtons?.length &&
                                    <div className=" w-p-94 mx-auto bg-color-disabled-btn-unauth py-1 br-2 my-2">
                                        <div className="h3-medium ml-2">Quick Reply</div>

                                        {quickReplyButtons.map((x, index) => {
                                            return <div className={`c-move d-flex align-center  bg-color-secondary w-p-96 mx-auto br-2 mt-1 justify-between ${x.ActionType === QuickReply.Custom ? "" : ""}`}
                                                draggable
                                                onDragStart={() => (dragStart.current = index)}
                                                onDragEnter={() => (dragEnter.current = index)}
                                                onDragEnd={() => handelDrag(ButtonTypes.QuickReply)}
                                                onDragOver={(e) => e.preventDefault()}
                                            >
                                                <div className=" w-p-85 mx-auto br-2">
                                                    <div className="p-2">
                                                        <div className="d-flex justify-between w-p-100">
                                                            <div className="w-p-45">
                                                                <div className="h5-regular color-text-field-label">Type</div>
                                                                <div className="">
                                                                    <Autocomplete
                                                                        disablePortal
                                                                        options={QucikReplyTypeOptions}
                                                                        size="small"
                                                                        disableClearable
                                                                        getOptionLabel={(option: any) => option?.Name}
                                                                        value={QucikReplyTypeOptions.find(option => option.Value === x.ActionType)}
                                                                        getOptionDisabled={(option) => {
                                                                            const count = quickReplyButtons?.filter(x => x.ActionType === option?.Value)?.length || 0;

                                                                            if ((option.Value === QuickReply.Marketing)) {
                                                                                return count >= 1;
                                                                            } else {
                                                                                return false;
                                                                            }
                                                                        }}
                                                                        onChange={(e, value) => onChangeQuickReplyAction(e, value, x.Id)}
                                                                        renderInput={(params) => <TextField {...params} />}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="w-p-45">
                                                                <div className="h5-regular color-text-field-label">Button text</div>
                                                                <div className="">
                                                                    <TextField
                                                                        className="w-p-100"
                                                                        size="small"
                                                                        value={x.ButtonText}
                                                                        onChange={(e) => onChangeQuickReplyButtonText(e, x.Id)}
                                                                        disabled={x.ActionType === QuickReply.Marketing}
                                                                        InputProps={{
                                                                            style: {
                                                                                backgroundColor: x.ActionType === QuickReply.Marketing ? '#F1F4F7' : 'transparent',
                                                                            }
                                                                        }}
                                                                        error={!!x.ButtonTextError}
                                                                        inputProps={{ maxLength: x.ActionType === 2 ? 25 : 100 }}
                                                                        helperText={<div className="h6-medium w-p-100 d-flex justify-flex-end">{x.ButtonTextError}</div>}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {x.ActionType === QuickReply.Marketing &&
                                                            <div className="d-flex justify-between mt-2 w-p-100">
                                                                <div className="w-p-100">
                                                                    <div className="h5-regular color-text-field-label">Foot note</div>
                                                                    <div className="w-p-100">
                                                                        <TextField
                                                                            className="w-p-100"
                                                                            size="small"
                                                                            value={x.FooterText}
                                                                            onChange={(e) => onChangeQuickReplyFooterText(e, x.Id)}
                                                                            disabled={x.ActionType === QuickReply.Marketing}
                                                                            InputProps={{
                                                                                style: {
                                                                                    backgroundColor: x.ActionType === QuickReply.Marketing ? '#F1F4F7' : 'transparent',
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }

                                                        {x.ActionType === QuickReply.Marketing &&
                                                            <div className="d-flex align-center mt-1">
                                                                <Checkbox checked={marketingOptOutChecked} onChange={(event) => setMarketingOptOutChecked(event.target.checked)} className="mb-auto p-0 mr-1 " size="small" classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }} />
                                                                <div className="h6-regular color-text-field-label">
                                                                    I understand that it's Test WhatsApp Business Account's responsibility to stop sending marketing messages to customers who opt out.
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="w-p-10 d-flex flex-direction justify-center align-center  h-p-100 br-2">
                                                    <DeleteButtonIcon onClick={() => removeQuickReply(x.Id)} className="c-pointer " />
                                                    <DragHolderGrayIcon className="mt-1" />
                                                </div>
                                            </div>
                                        })
                                        }
                                    </div>
                                }
                                </div>
                            </div>
                        </div>
                        {templateType === "UtilityCustom" &&
                            <div className="w-p-86 add-phone-number-paper-border br-2 mx-auto mt-2 py-2">
                                <div className="w-p-94 h-4 d-flex align-center h4-medium color-primary-accent mx-auto">
                                    Message validity period
                                </div>
                                <div className="w-p-94 d-flex align-center h5-regular color-text-field-label mx-auto">
                                    You can set a custom validity period that your utility message must be delivered by before it expires. If a message has not been delivered within this time frame, you will not be charged and your customer will not see the message.
                                </div>
                                <div className="w-p-94 h-4 d-flex align-center h4-medium color-primary-accent mx-auto">
                                    Set custom validity period for your message
                                </div>
                                <div className="w-p-94 d-flex align-center h5-regular color-text-field-label mx-auto">
                                    <div className="w-p-70">
                                        If you don't set a custom validity period, the standard 30 days WhatsApp message validity period will be applied.
                                    </div>
                                    <div className="w-p-30 d-flex justify-flex-end mb-auto">
                                        <CustomSwitch
                                            checked={customValidityPeriod}
                                            onChange={(checked: boolean) => setCustomValidityPeriod(checked)}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="w-p-86 mx-auto mt-2 py-2 d-flex ">
                            <ButtonComponent ButtonLabel={"Back"} OnClick={() => { navigate(-1) }} Variant={"secondary-btn"} ClassName="ml-auto mr-2"></ButtonComponent>
                            <ButtonComponent ButtonLabel={"Create template"} OnClick={() => { createTemplate() }} Variant={(errors.body || errors.buttons || errors.header || errors.templateName) ? "disabled-btn" : "primary-btn"} Loading={isloading} ClassName=""></ButtonComponent>
                        </div>
                    </div>
                </div>
                <div className="w-p-40 h-p-100 d-flex flex-direction align-center">
                    <div className="w-p-100 h-p-4 d-flex justify-center align-center h4-semibold color-nav-bar-font-color">
                    </div>
                    <div className={`h-p-90 w-p-80 add-phone-number-paper-border br-3 d-flex align-center flex-direction min-w-40`}>
                        <div className="w-p-88 max-h-60 max-w-38 min-w-38 mt-4 p-relative">
                            <div className={`whatsapp-template-background w-p-100 ${allAddedButtons.length > 6 && showAll && "min-h-50"} max-h-60 br-3 d-flex justify-center o-y-scroll`}>
                                {((header && headerType !== "None") || body !== initialValue || footer) && <div className="message received w-30 my-4 d-flex flex-direction align-center">
                                    {headerType === "Text" && header &&
                                        <div className="w-28 mt-1 h4-semibold">
                                            {header?.replace("{{1}}", headerVariable)}
                                        </div>
                                    }

                                    {(headerType !== "Text" && !!media) &&
                                        <div className="d-flex align-center w-28">{getMediaTypeIcon(mediatype, mediaUrl, "w-p-100 min-w-28 mt-1 max-h-28")}</div>
                                    }

                                    {body !== initialValue &&
                                        <div className="w-28 d-flex align-center h5-regular w-break my-1">
                                            {bodyPreview}
                                            {/* <RichEditor IsMobileDevice={false} value={body} setValue={() => { }} isRedonly={true} /> */}
                                        </div>
                                    }
                                    {footer &&
                                        <div className="w-28 h6-medium color-secondary-light-hover w-break">
                                            {footer}
                                        </div>
                                    }
                                    <div className="d-flex w-28 justify-flex-end h6-medium color-secondary-light-hover">{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
                                    {
                                        !!allAddedButtons?.length &&
                                        allAddedButtons.slice(0, 3).map((x, index) => (
                                            <div key={index} className={`w-28 h-5 h5-medium color-whatsapp-template-buttons ${index < 2 ? 'bb-primary-background-pink-2' : ''} ${index === 0 ? "bt-primary-divider-2" : ""} d-flex justify-center align-center h4-semibold`} onClick={!(index < 2 || allAddedButtons.length === 3) ? () => { setShowAll(true) } : () => { }}>
                                                {(index < 2 || allAddedButtons.length === 3) && (x.ActionType === 3 ? <WhatsappTemplateVisitWebsiteIcon className="w-2 h-2 mr-1" /> : x.ActionType === 4 ? <WhatsappTemplateCallPhonenumberIcon className="w-2 h-2 mr-1" /> : x.ActionType === 5 ? <WhatsappTemplateCopyOfferCodeIcon className="w-2 h-2 mr-1" /> : <WhatsappTemplateQuickReplyIcon className="w-2 h-2 mr-1" />)}
                                                {index < 2 ? `${x?.ButtonText}` : allAddedButtons.length === 3 ? `${x.ButtonText}` :
                                                    !showAll ?
                                                        <div className="d-flex align-center c-pointer">
                                                            <ShowAllIcon />
                                                            <div className="ml-1">See all options</div>
                                                        </div>
                                                        : `${x?.ButtonText}`
                                                }
                                            </div>
                                        ))
                                    }
                                </div>
                                }

                                {
                                    <div className={`slideShowAll ${showAll ? 'visible' : ''} w-p-90 mx-auto brt-1`}>
                                        <div className="p-1 d-flex justify-flex-end c-pointer" onClick={() => setShowAll(false)}><CancelIcon /></div>
                                        {allAddedButtons.map((x, index) => (
                                            <div key={index} className={` h-4 h5-medium color-whatsapp-template-buttons ${index === (!!quickReplyOrder && quickReplyOrder === 1 ? quickReplyButtons.length - 1 : callToActionButtons.length - 1) ? 'bb-primary-background-pink-2' : ''}  d-flex justify-center align-center h4-semibold`}  >
                                                {x.ActionType === 3 ? <WhatsappTemplateVisitWebsiteIcon className="w-2 h-2 mr-1" /> : x.ActionType === 4 ? <WhatsappTemplateCallPhonenumberIcon className="w-2 h-2 mr-1" /> : x.ActionType === 5 ? <WhatsappTemplateCopyOfferCodeIcon className="w-2 h-2 mr-1" /> : <WhatsappTemplateQuickReplyIcon className="w-2 h-2 mr-1" />}
                                                {`${x?.ButtonText}`
                                                }
                                            </div>
                                        ))}
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="w-p-80 h-p-20 max-w-38 min-w-38 d-flex justify-center align-center h6-regular flex-direction color-secondary-light-hover">
                            <div className="d-flex">
                                <WhatsappTemplateInfoIcon className="mr-1" width={12} height={12} />
                                <span>This template is good for order confirmations,</span>
                            </div>
                            <div>account update, receipts, reminders, billing.</div>
                        </div>
                    </div>
                </div>
            </div>
            {
                Boolean(anchorAddButon) &&
                <Popover
                    open={Boolean(anchorAddButon)}
                    anchorEl={anchorAddButon}
                    onClose={() => setAnchorAddButton(null)}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    classes={{ paper: `w-25` }}
                >
                    <div className='d-flex flex-direction o-hidden p-1'>
                        <div className="bb-primary-divider-1 h5-semibold color-primary-light py-1">
                            Quick reply Buttons
                        </div>
                        {
                            templateType !== "UtilityCustom" && <div className={`h-4  h-5 px-1 mt-1 br-1 ${!!quickReplyButtons.filter(x => x.ActionType === QuickReply.Marketing)?.length ? "color-disabled-btn-unauth" : "color-primary-accent c-pointer"}`} onClick={quickReplyButtons.filter(x => x.ActionType === QuickReply.Marketing)?.length ? () => { } : () => onChangeQuickReply(QuickReply.Marketing)}>
                                <div className="h5-semibold">Marketing opt-out</div>
                                <div className="h6-regular">Recommended</div>
                            </div>
                        }
                        <div className={` h-4 px-1 mt-1 br-1 color-primary-accent c-pointer`} onClick={() => onChangeQuickReply(QuickReply.Custom)}>
                            <div className="h5-semibold">Custom</div>
                        </div>

                        <div className="bb-primary-divider-1 h5-semibold color-primary-light pb-1">
                            Call-to-action Buttons
                        </div>

                        <div className={` h-4 h-5 px-1 mt-1 br-1 ${callToActionButtons.filter(x => x.ActionType === CallToAction.VisitWebSite)?.length >= 2 ? "color-disabled-btn-unauth" : "color-primary-accent c-pointer"}`} onClick={callToActionButtons.filter(x => x.ActionType === CallToAction.VisitWebSite)?.length >= 2 ? () => { } : () => onChangeCallToAction(CallToAction.VisitWebSite)}>
                            <div className="h5-semibold ">Visit Website</div>
                            <div className="h6-regular ">2 buttons maximum</div>
                        </div>
                        <div className={`h-4 h-5 px-1 mt-1 br-1 ${!!callToActionButtons.filter(x => x.ActionType === CallToAction.CallPhonenumber)?.length ? "color-disabled-btn-unauth" : "color-primary-accent c-pointer"}`} onClick={!!callToActionButtons.filter(x => x.ActionType === CallToAction.CallPhonenumber)?.length ? () => { } : () => onChangeCallToAction(CallToAction.CallPhonenumber)}>
                            <div className="h5-semibold ">Call phone number</div>
                            <div className="h6-regular ">1 buttons maximum</div>
                        </div>
                        <div className={`h-4 h-5 px-1 mt-1 br-1 ${!!callToActionButtons.filter(x => x.ActionType === CallToAction.CopyOfferCode)?.length ? "color-disabled-btn-unauth" : "color-primary-accent c-pointer"}`} onClick={!!callToActionButtons.filter(x => x.ActionType === CallToAction.CopyOfferCode)?.length ? () => { } : () => onChangeCallToAction(CallToAction.CopyOfferCode)}>
                            <div className="h5-semibold ">Copy offer code</div>
                            <div className="h6-regular ">1 buttons maximum</div>
                        </div>
                    </div>
                </Popover>
            }
        </div >
    )
}

export default AddWhatsappTemplateEditAndPreviewComponent;